import React, { useEffect, useState } from "react";
import { Col, Container, ListGroup, Row, Spinner } from "react-bootstrap";
import { Link, useLocation, useNavigate } from "react-router-dom";

import { ImageElement } from "components";

import userRouteMap from "routes/User/userRouteMap";
import { commonService } from "services/common.service";
import { BROKER_ENDPOINT } from "apiEndpoints";
import socketEventManager from "socket/socketEvents";

function AmenitiesModel() {
  const navigate = useNavigate();
  const location = useLocation();
  const [state, setState] = useState({
    isLoading: true,
    lists: [],
  });

  const getPageDetails = async () => {
    try {
      const response = await commonService({
        apiEndPoint: BROKER_ENDPOINT.getCategoryDetails(location.state?.id),
      });
      setState((prevState) => ({
        ...prevState,
        isLoading: false,
        lists: response?.data?.data ?? [],
      }));
    } catch (error) {
      setState((prevState) => ({
        ...prevState,
        isLoading: false,
      }));
    }
  };
  const handleOnLoadSocketCommand = (item) => { 
    console.log("item", item);
    const object = {
      hardware_id: item?.parent_category?.hardware_id,
      broker_id: item?.parent_category?.broker_id,
      sub_sub_category_id: item?.parent_category?.sub_sub_category_id,
      type : "gallery_image",
      image_id : item?.parent_category?.id,
      image_url : item?.parent_category?.category_image,
    }    
    socketEventManager.sendCommand(item?.parent_category?.hardware_id, object);
  } 

  useEffect(() => {
    if (!location.state) {
      navigate("/");
    } else {
      getPageDetails();
    }
  }, []);

  return (
    <div className="modelGallery">
      <Container fluid className="p-0">
        <Row className="gx-0">
          <Col md={6}>
            <div className="modelGallery_left commonLeftImg">
              <ImageElement
               onLoad={() => handleOnLoadSocketCommand(state.lists[0])}
                imageFor="user"
                previewSource={
                  state.lists[0]?.parent_category?.category_image ??
                  location.state?.primary_media
                } 
                className="w-100"
              />
            </div>
          </Col>
          <Col md={6}>
            <div className="modelGallery_right d-flex flex-column justify-content-between align-items-center h-100vh">
              <header className="header w-100 d-flex align-items-center position-relative">
                <div className="header_title mx-auto">
                  <h1 className="mb-0">Amenities Model</h1>
                </div>
                <Link className="header_logo" to={userRouteMap.LANDING.path}>
                  <ImageElement
                    imageFor="user"
                    source="logo.svg"
                    className="img-fluid"
                  />
                </Link>
              </header>
              {state.isLoading ? (
                <div className="d-flex justify-content-center align-items-center m-auto">
                  <Spinner />
                </div>
              ) : !state.isLoading && state.lists.length > 0 ? (
                <div className="multiList multiList-list text-center innerScroll d-flex flex-column justify-content-around align-items-center px-3">
                  <ListGroup>
                    {state.lists.map((listItem, listIdx) => (
                      <ListGroup.Item key={listIdx} className="multiList_item">
                        <Link
                          className="multiList_item_tab"
                          to={userRouteMap.AMENITIES_MODEL_FLOORS.path}
                          state={listItem}
                        >
                          {listItem?.name}
                        </Link>
                      </ListGroup.Item>
                    ))}
                  </ListGroup>
                </div>
              ) : (
                <div className="d-flex justify-content-center align-items-center vh-100">
                  No data found
                </div>
              )}
              <Link
                className="commonBack text-uppercase d-block h-auto"
                onClick={() => navigate(-1)}
              >
                <em className="icon-back" />
                <span className="d-block">Back</span>
              </Link>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default AmenitiesModel;
